
import { Component, Prop, Vue } from "vue-property-decorator";
import CelebrusMonOffre from "@/components/CelebrusMonOffre.vue";
import CelebrusCgPromo from "@/components/CelebrusCgPromo.vue";
import CelebrusFicheProduit from "@/components/CelebrusFicheProduit.vue";
import CelebrusHbHub from "@/components/CelebrusHbHub.vue";
import CelebrusHbRop from "@/components/CelebrusHbRop.vue";
import CelebrusHbPopin from "@/components/CelebrusHbPopin.vue";
import CelebrusHbMessagerie from "@/components/CelebrusHbMessagerie.vue";
import CelebrusHbAlerte from "@/components/CelebrusHbAlerte.vue";
import CelebrusMenuNotreOffre from "@/components/CelebrusMenuNotreOffre.vue";
import CelebrusMenuNotreOffre2 from "@/components/CelebrusMenuNotreOffre2.vue";
import CelebrusConfirmationVirement from "@/components/CelebrusConfirmationVirement.vue";
import CelebrusVignettesFicheProduit from "@/components/CelebrusVignettesFicheProduit.vue";
import CelebrusSideAnimation from "@/components/CelebrusSideAnimation.vue";
import CelebrusSideRebond from "@/components/CelebrusSideRebond.vue";
import CelebrusHubOffres from "@/components/CelebrusHubOffres.vue";
import methodList from "@/config/Common.ts";

@Component({
  components: {
    CelebrusMonOffre,
    CelebrusCgPromo,
    CelebrusFicheProduit,
    CelebrusHbHub,
    CelebrusHbRop,
    CelebrusHbPopin,
    CelebrusHbMessagerie,
    CelebrusHbAlerte,
    CelebrusMenuNotreOffre,
    CelebrusMenuNotreOffre2,
    CelebrusVignettesFicheProduit,
    CelebrusConfirmationVirement,
    CelebrusSideAnimation,
    CelebrusSideRebond,
    CelebrusHubOffres
  }
})
export default class BannerContainer extends Vue {
  @Prop() private banner!: any;
  private observer = new MutationObserver(this.sendTrackingOnVisible);
  private methods = methodList;

  public mounted() {
    // On écoute les events resize et scroll et la modification du DOM
    window.addEventListener("resize" , this.sendTrackingOnVisible);
    document.addEventListener("scroll" , this.sendTrackingOnVisible);
    this.sendTrackingOnVisible();

    // On observe l'ouverture du menu nav-offre
    const target = document.querySelector(".sm-notre-offre");
    if (!!target) {
      this.observer.observe( target, {attributes: true});
    }
  }

  private sendTrackingOnVisible() {
    const targetContainer = this.$el;
    const targetPosition = targetContainer.getBoundingClientRect();
    const menuNotreOffre = targetContainer.closest(".sm-notre-offre");

    if (targetContainer !== null) {
      const containerStyle = window.getComputedStyle(targetContainer);
      const mostlyVisible = ( window.innerHeight - targetPosition.top) / targetPosition.height * 100 > 90 &&
                            ( targetPosition.top + targetPosition.height > targetPosition.height * 0.9 );
      const displayed =     containerStyle.visibility !== "hidden" && containerStyle.display !== "none";
      const parentVisible = !!(targetContainer as HTMLElement).offsetParent;
      const visibleInMenu = !!menuNotreOffre ? menuNotreOffre.getAttribute("aria-expanded") === "true" : true;
      if ( !mostlyVisible || !displayed || !parentVisible || !visibleInMenu ) {
        return false;
      }

      this.runBannerTracking();
      // On enleve les évents et l'observateur pour éviter les doublons
      window.removeEventListener("resize", this.sendTrackingOnVisible);
      document.removeEventListener("scroll", this.sendTrackingOnVisible);
      this.observer.disconnect();
    }
  }

  private runBannerTracking() {
    // Acknowledge banner display on Celebrus
    if (this.banner.celebrusHelper) {
      this.banner.celebrusHelper.extended();
    }

    // Acknowledge banner display on Adobe
    this.addAdobeTracking();
  }

  private createDigitalDataEntry() {
    const _entry = {
      Emplacement: this.banner.location,
      Nom: this.banner.messageId,
      Provenance: "rtim",
      url: window.location.pathname
    };
    return _entry;
  }

  private addDigitalDataBannerEntry(banner) {
    try {
      const banners = JSON.stringify((window as any).digitalData.modules.crmd.banners);
      if (!(RegExp(this.banner.location)).test(banners)) {
          (window as any).digitalData.modules.crmd.banners.push(banner);
      }
    } catch (e) {
      console.log(e);
    }
  }

  private addAdobeTracking() {
    this.addDigitalDataBannerEntry(this.createDigitalDataEntry());
  }

  private async onCloseClick() {
    window.dispatchEvent(
      new CustomEvent(`rtim-banner:${this.banner.location}`, {
        detail: {
          content: {},
          placement: {
            id: this.banner.location,
            size: "1260x630",
            zone: "udc-top"
          }
        }
      })
    );
    this.banner.celebrusHelper.refused();
  }
}
